import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/shared/SEO";
import { useI18n } from "@/context/I18nContext";
import { api, unwrap } from "@/lib/api";

import serviceAgreementEn from "@/content/agreements/service_agreement_v1_en.md";
import serviceAgreementEs from "@/content/agreements/service_agreement_v1_es.md";

// The content of these agreements lives in /src/content/agreements as plain
// markdown files. When the legal review comes back, the lawyer can ship a
// version bump as a single-file PR.
export default function ServiceAgreementPage() {
  const { locale } = useI18n();
  const [phone, setPhone] = useState("");
  useEffect(() => {
    api.get("/public/settings").then((r) => {
      const d = unwrap(r) || {};
      setPhone(d.company_phone || d.support_phone || "");
    }).catch(() => {});
  }, []);
  const body = locale === "es" ? serviceAgreementEs : serviceAgreementEn;
  const reviewed = new Date().toLocaleDateString(locale === "es" ? "es-ES" : "en-US", {
    year: "numeric", month: "long", day: "numeric",
  });
  const title = locale === "es" ? "Acuerdo de Servicio — Ever Clean Home" : "Service Agreement — Ever Clean Home";
  const desc = locale === "es"
    ? "Acuerdo de Servicio entre el cliente y Ever Clean Home. Borrador pendiente de revisión legal."
    : "Service Agreement between the customer and Ever Clean Home. Draft pending legal review.";
  const footerNote = locale === "es"
    ? `Última revisión: ${reviewed}. Para preguntas legales específicas, contactar legal@evercleanhome.online.`
    : `Last reviewed: ${reviewed}. For specific legal questions, contact legal@evercleanhome.online.`;

  return (
    <div className="min-h-screen bg-[#FAFAF9]" data-testid="service-agreement-page">
      <SEO title={title} description={desc} noindex />
      <Header />
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 prose prose-stone prose-headings:font-display prose-headings:tracking-tight prose-h1:text-4xl prose-h1:font-extrabold">
        <ReactMarkdown>{body}</ReactMarkdown>
        {phone && (
          <p className="text-sm not-prose mt-6" data-testid="service-agreement-phone">
            <strong>{locale === "es" ? "Teléfono:" : "Phone:"}</strong>{" "}
            <a href={`tel:${phone.replace(/[^0-9+]/g, "")}`} className="text-[#0F766E]">{phone}</a>
          </p>
        )}
        <p className="text-xs text-[#9CA3AF] mt-10 not-prose" data-testid="service-agreement-footer-note">
          <em>{footerNote}</em>
        </p>
      </div>
      <Footer />
    </div>
  );
}
